(function () {
  'use strict';
  var modal = document.querySelector('[data-welcome-modal]');
  if (!modal || modal.dataset.initialized) return;
  modal.dataset.initialized = 'true';
  if (!/\/products\/formula-no5-hair-growth-serum\/?$/.test(location.pathname)) return;
  var seenKey = 'anagen_formula_no5_assessment_modal_seen';
  var suppressedKey = 'anagen_formula_no5_assessment_suppressed_after_add';
  try {
    sessionStorage.setItem('anagen_welcome_storage_check', '1');
    sessionStorage.removeItem('anagen_welcome_storage_check');
  } catch (_) { return; }
  function stored(key) { try { return sessionStorage.getItem(key); } catch (_) { return null; } }
  function store(key, value) { try { sessionStorage.setItem(key, value); } catch (_) {} }
  if (stored(seenKey) || stored(suppressedKey)) return;

  var addButton = document.querySelector('.product-form__submit');
  if (!addButton) return;
  var dialog = modal.querySelector('.al-assessment-modal__dialog');
  var offer = modal.querySelector('[data-welcome-offer]');
  var invite = modal.querySelector('[data-assessment-invite]');
  var quiz = modal.querySelector('[data-assessment-quiz]');
  var status = modal.querySelector('[data-welcome-status]');
  var start = modal.querySelector('[data-assessment-start]');
  var code = modal.dataset.code;
  var timer, shown = false, added = false, revealed = false, opener;
  var originalOverflow = '', quizLoaded = false, loadingQuiz = false;
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  function hydrateImages(container) {
    container.querySelectorAll('[data-welcome-image]').forEach(function (img) {
      if (!img.getAttribute('src')) img.src = img.dataset.welcomeImage;
    });
  }
  function show() {
    if (shown || added || document.hidden || stored(suppressedKey)) return;
    shown = true;
    store(seenKey, '1');
    opener = document.activeElement;
    originalOverflow = document.documentElement.style.overflow;
    hydrateImages(offer);
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    modal.querySelector('[data-welcome-reveal]').focus({ preventScroll: true });
  }
  function close() {
    if (modal.hidden) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = originalOverflow;
    if (opener && opener.isConnected && opener.focus) opener.focus({ preventScroll: true });
  }
  function cancel() { clearTimeout(timer); timer = null; }
  function schedule() {
    if (timer || shown || added) return;
    hydrateImages(offer);
    timer = setTimeout(function () { timer = null; show(); }, 5000);
  }
  function suppress() { added = true; store(suppressedKey, '1'); cancel(); }
  addButton.addEventListener('click', suppress, true);
  document.addEventListener('click', function (event) {
    if (event.target.closest('.product-form__submit,.new-product-form__submit')) suppress();
  }, true);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && !shown && !added) schedule();
  });
  modal.querySelectorAll('[data-assessment-close]').forEach(function (button) { button.addEventListener('click', close); });

  async function saveDiscount() {
    status.textContent = modal.dataset.saving;
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 10000);
    try {
      var existing = await fetch(root + 'cart.js', { credentials: 'same-origin', signal: controller.signal });
      if (!existing.ok) throw new Error('cart');
      var cart = await existing.json();
      var codes = (cart.discount_codes || []).map(function (discount) { return discount.code; }).filter(Boolean);
      if (!codes.some(function (value) { return value.toUpperCase() === code; })) codes.push(code);
      var response = await fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', signal: controller.signal,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      });
      var result = await response.json();
      if (!response.ok || result.status) throw new Error('discount');
      store('anagen_welcome_code', code);
      status.textContent = modal.dataset.saved;
    } catch (_) { status.textContent = modal.dataset.fallback; }
    finally { clearTimeout(timeout); }
  }
  modal.querySelector('[data-welcome-reveal]').addEventListener('click', function () {
    if (revealed) return;
    revealed = true;
    offer.hidden = true;
    invite.hidden = false;
    hydrateImages(invite);
    dialog.dataset.welcomeStage = 'invite';
    dialog.setAttribute('aria-labelledby', 'al-welcome-assessment-title');
    dialog.scrollTop = 0;
    dialog.focus({ preventScroll: true });
    saveDiscount();
  });
  modal.querySelector('[data-welcome-copy]').addEventListener('click', async function (event) {
    var copyButton = event.currentTarget;
    try { await navigator.clipboard.writeText(code); copyButton.textContent = modal.dataset.copied; copyButton.classList.add('is-copied'); }
    catch (_) { status.textContent = modal.dataset.copyFailed; }
  });

  var resources = {};
  function load(url, style) {
    if (resources[url]) return resources[url];
    resources[url] = new Promise(function (resolve, reject) {
      var element = document.createElement(style ? 'link' : 'script');
      if (style) { element.rel = 'stylesheet'; element.href = url; } else { element.src = url; }
      var timeout = setTimeout(fail, 15000);
      function fail() { clearTimeout(timeout); element.remove(); delete resources[url]; reject(new Error('asset')); }
      element.onload = function () { clearTimeout(timeout); resolve(); };
      element.onerror = fail;
      document.head.appendChild(element);
    });
    return resources[url];
  }
  if (start) start.addEventListener('click', async function () {
    if (loadingQuiz) return;
    loadingQuiz = true;
    start.disabled = true;
    try {
      if (!quizLoaded) {
        await Promise.all([load(modal.dataset.quizCss, true), load(modal.dataset.resultCss, true)]);
        await load(modal.dataset.resultJs, false);
        await load(modal.dataset.quizJs, false);
        quizLoaded = true;
      }
      invite.hidden = true;
      quiz.hidden = false;
      dialog.dataset.welcomeStage = 'quiz';
      dialog.removeAttribute('aria-labelledby');
      dialog.setAttribute('aria-label', start.textContent.trim());
      dialog.scrollTop = 0;
      var opening = quiz.querySelector('[data-screen="start"].is-on [data-start]');
      if (opening) opening.click();
      dialog.focus({ preventScroll: true });
    } catch (_) { status.textContent = modal.dataset.loadFailed; }
    finally { loadingQuiz = false; start.disabled = false; }
  });
  document.addEventListener('keydown', function (event) {
    if (modal.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    var focusable = Array.from(dialog.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')).filter(function (el) {
      return !el.disabled && el.tabIndex >= 0 && el.getClientRects().length > 0;
    });
    var first = focusable[0], last = focusable[focusable.length - 1], active = document.activeElement;
    if (!first) { event.preventDefault(); dialog.focus(); }
    else if (event.shiftKey && (active === first || !focusable.includes(active))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (active === last || !focusable.includes(active))) { event.preventDefault(); first.focus(); }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else { schedule(); }
}());
